import axiosRaw from 'axios';
import { deduplicateAxios } from 'src/utils/requestDedup';
import { API_URL, HANDSFREE_URL, PAYMENT_API_URL } from 'src/constants/urls';

const axios = deduplicateAxios(axiosRaw);
const PAYMENT_3D_CALLBACK_URL = process.env.REACT_APP_PAYMENT_3D_CALLBACK_URL;

// const API_URL = process.env.REACT_APP_API_URL;
// const HANDSFREE_URL = process.env.HANDSFREE_APP_API_URL;

export default {
  EditPassword(password) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_UPDATE_PROFILE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        password: password,
      },
    });
  },

  async CreateOrder(array) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_MALL_LOGISTICS_CREATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: array,
    });
  },

  Login(username, password) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_LOGIN}`,
      data: {
        username: username,
        password: password,
      },
    });
  },

  ForgotPassword(username) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FORGET_PASSWORD}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        username: username,
      },
    });
  },

  GetPoints(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_POINTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetToken() {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_GET_TOKEN}`,
      data: {
        key: 'CeQJ3t6OT8Ka5RTiDPU1tBepbUQumY',
        secret: '4VtrWHHHrWYmnYUlOHncj7DSlapfhA',
      },
    });
  },
  UpdateProfile(token, user) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_UPDATE_PROFILE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: user,
    });
  },

  CreateEmployee(token, user) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_USERS_CREATE_EMPLOYEE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: user,
    });
  },

  GetStores(token, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_MALLS_BRANCHES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
      },
    });
  },
  GetMalls(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_MALLS_GET_MALLS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetMallsWithoutToken() {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_GET_MALLS}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        withOffices: true,
      },
    });
  },

  GetMallsWithOffices(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_MALLS_GET_MALLS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        withOffices: true,
      },
    });
  },
  GetMallsForCreateEmployeeWithoutLogin() {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_GET_MALLS}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        withOffices: false,
      },
    });
  },
  GetMallsForSuperadminLogin(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_MALLS_GET_MALLS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        withOffices: true,
      },
    });
  },
  GetMallInformation(token, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_MALLS_GET_MALL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
      },
    });
  },
  SearchBranchByTaxNo(taxNo, mallID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_SEARCH_BRANCH_BY_TAX_NO}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        taxNo: taxNo,
        mallID: mallID,
      },
    });
  },

  UpdateBranch(token, easyMallSettings, branchID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_BRANCH_UPDATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        easyMallSettings: easyMallSettings,
        branchID: branchID,
      },
    });
  },

  CreateEmployeeWithoutLogin(userObj) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_USER_CREATE}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        mallID: userObj?.mallID,
        corporationID: userObj?.corporationID,
        branchID: userObj?.branchID,
        email: userObj?.email,
        phone: userObj?.phoneNumber,
        name: userObj?.firstName,
        lastname: userObj?.lastName,
        password: userObj?.password,
        username: userObj?.username,
        type: 'corporational',
        isAdministrator: false,
        accountCategory: 'store',
        frontAuth: ['operations'],
        authLocations: {
          branch: [userObj?.branchID],
        },
      },
    });
  },

  GetHandsFreeOrders(token, branchID) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_GET_LOCATION_ORDERS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallLogisticsID: branchID,
      },
    });
  },

  GetHandsfreeMall(token, mallID) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_GET_MALL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetHandsFreePosts(token, branchID, status) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_GET_BRANCH_POSTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallLogisticsID: branchID,
        status: status,
      },
    });
  },

  GetHandsFreeConfirm(token, orderID, count) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_ORDER_CONFIRM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        orderID: orderID,
        count: count,
      },
    });
  },

  GetHandsFreeReject(token, orderID) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_ORDER_REJECT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        orderID: orderID,
      },
    });
  },

  UpdateBranchesHandsfreeDeliveryTypeSettings(token, branchIDs, settings) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_UPDATE_BRANCHES_HANDSFREE_DELIVERY_TYPE_SETTINGS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchIDs: branchIDs,
        settings: settings,
      },
    });
  },

  GetMallsForHandsfree(token) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_GET_MALL_LIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  CreateHandsfreeByStore(
    token,
    locationID,
    formData,
    additionalNote,
    createdBy,
    deliveryTypeInfo
  ) {
    return axios({
      method: 'post',
      url: `${HANDSFREE_URL}${process.env.REACT_APP_ENDPOINT_HANDSFREE_FLOW_CREATE_ORDER_BY_STORE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationID: locationID,
        name: formData.name,
        lastname: formData.lastname,
        email: formData.email,
        inventory: formData.inventory,
        phone: formData.phone,
        additionalNote: additionalNote,
        createdBy: createdBy,
        deliveryTypeInfo,
      },
    });
  },

  GetPrices() {
    return axios({
      method: 'get',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_API_EASYPOINT_COM_TR_BOXAPI_BOX_LIST,
    });
  },

  GetLocation(token, branchID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_LOCATIONS_GET_LOCATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        branchID: branchID,
      },
    });
  },

  GetUsers(token, mallID, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_GET_USERS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        // type: 'corporational',
        mallID: mallID,
        status: status,
      },
    });
  },
  GetUsersByType(token, mallID, status, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_GET_USERS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
        mallID: mallID,
        status: status,
      },
    });
  },
  GetProfile(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_GET_PROFILE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetUser(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_GET_USER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
        withAuthOffices: true,
      },
    });
  },

  CreateTicket(token, title, description, type, files, username) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_SUPPORT_CREATE_TICKET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        files: files,
        type: type,
        username: username,
      },
    });
  },

  GetUserByID(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_GET_USER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetReport(token, queryType, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_REPORT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: 'auto',
        queryType: queryType,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  GetUserForTickets(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_GET_USER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetTickets(token, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: status,
      },
    });
  },

  GetTicketsUser(token, createdBy) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        createdBy: createdBy,
      },
    });
  },

  GetTicketsStaff(token, responsibleBy) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        responsibleBy: responsibleBy,
        status: 3,
        operator: 'or',
      },
    });
  },

  GetTicketsManager(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        status: [1, 3, 4],
      },
    });
  },

  GetTicket(token, id) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TICKET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id: id,
      },
    });
  },

  GetTicketsByUser(token, createdBy) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TICKETS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        createdBy: createdBy,
      },
    });
  },

  UserUpdate(token, frontAuth, userID, isAdministrator) {
    //  console.log('Service Response', {
    //   token: token,
    //   frontAuth: frontAuth,
    //   userID: userID,
    //   isAdministrator: isAdministrator,
    // });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_UPDATE_PROFILE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        frontAuth: frontAuth,
        userID: userID,
        isAdministrator: isAdministrator,
      },
    });
  },

  UserSetActive(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_USER_SET_ACTIVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  UserSetPassive(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_USER_SET_PASSIVE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },

  GetStatisticsByMall(token, mallID, type, date) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ANALYTICS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
        type: type,
        date: date,
      },
    });
  },

  GetStatisticsByBranch(token, branchID, type, date) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ANALYTICS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchID,
        type: type,
        date: date,
      },
    });
  },

  GetCargoStatisticsByMall(token, mallID, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ANALYTICS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
        type: type,
        status: 1,
      },
    });
  },

  GetCargoStatisticsByBranch(token, branchID, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ANALYTICS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchID,
        type: type,
        status: 1,
      },
    });
  },

  GetGraphStatisticsByBranch(token, branchID, type, date, onlyCompleted) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ANALYTICS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchID,
        type: type,
        date: date,
        onlyCompleted: onlyCompleted,
      },
    });
  },

  GetGraphStatisticsByMall(token, mallID, type, date, onlyCompleted) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ANALYTICS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
        type: type,
        date: date,
        onlyCompleted: onlyCompleted,
      },
    });
  },

  GetAgreement(token, handle) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_AGREEMENTS_GET_STATIC}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        handle: handle,
      },
    });
  },
  GetAgreementWithoutToken(handle) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_AGREEMENTS_GET_AGREEMENT}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        agreementID: handle,
      },
    });
  },

  CreatePreHandshake(
    token,
    mallID,
    branchID,
    details,
    username,
    password,
    totalPackageCount,
    storeConfirmation
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_HANDSHAKES_CREATE_PRE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
        branchID: branchID,
        details: details,
        username: username,
        password: password,
        totalPackageCount: totalPackageCount,
        storeConfirmation: storeConfirmation,
      },
    });
  },
  GetCampaigns(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_CAMPAIGNS_GET_CAMPAIGNS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        audiences: ['mall-logistics', 'corporational-customers', 'porters'],
        allCampaigns: true,
      },
    });
  },

  CreateCampaign(
    token,
    title,
    description,
    start,
    end,
    images,
    link,
    targetAudience
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_CAMPAIGNS_CREATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: title,
        description: description,
        targetAudience: targetAudience,
        start: start,
        end: end,
        link: link,
        images: images,
      },
    });
  },
  UpdateCampaign(
    token,
    campaignID,
    title,
    description,
    start,
    end,
    images,
    link,
    targetAudience,
    status
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_CAMPAIGNS_UPDATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        campaignID: campaignID,
        title: title,
        description: description,
        targetAudience: targetAudience,
        start: start,
        end: end,
        link: link,
        images: images,
        status: status,
      },
    });
  },

  GetDropboxLocations(token) {
    return axios({
      method: 'get',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_DROP_BOX_GET_LOCATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetDropboxListByLocations(token, locationCode, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_DROP_BOX_LIST_BY_LOCATION_CODE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  GetCheckRoomTransactions(token, locationCode, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CHECKROOM_TRANSACTIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  UpdateMallLogisticsPost(
    token,
    postID,
    barcode,
    shipmentFirm,
    orderInventory,
    tower,
    office,
    customerName,
    customer,
    companyName,
    from,
    to
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_MALL_LOGISTICS_UPDATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        barcode: barcode,
        shipmentFirm: shipmentFirm,
        orderInventory: orderInventory,
        tower: tower,
        office: office,
        customerName: customerName,
        customer: customer,
        companyName: companyName,
        from: from,
        to: to,
      },
    });
  },

  GetCargoFirms(token) {
    return axios({
      method: 'get',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_CARGO_FIRMS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  CreateHandover(token, postID, message, name, lastname, phone, note) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_HANDOVER_MALLLOGISTICS_CREATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
        message: message,
        name: name,
        lastname: lastname,
        phone: phone,
        note: note,
      },
    });
  },

  GetDropBoxLocations(token) {
    return axios({
      method: 'get',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_DROP_BOX_GET_LOCATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetCheckroomLocations(token) {
    return axios({
      method: 'get',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CHECKROOM_GET_LOCATIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  AddTransportationTool(token, toolTitle) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_MALL_TRANSPORTATION_TOOL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: toolTitle,
      },
    });
  },

  GetTransportationTools(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_MALLS_TRANSPORTATION_TOOLS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  AssignPorter(token, porterID, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ASSIGN_PORTER_TO_POST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        porterID: porterID,
        postID: postID,
      },
    });
  },

  ReassignPorter(token, porterID, postID, transactionID) {
    console.log({ porterID, postID, transactionID });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_RE_ASSIGN_PORTER_TO_POST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        porterID: porterID,
        postID: postID,
        transactionID: transactionID,
      },
    });
  },

  GetTransactions(token, postID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_TRANSACTIONS_GET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        postID: postID,
      },
    });
  },

  GetHandoverLogsSearch(
    token,
    barcode,
    phone,
    createdBy,
    startDate,
    endDate,
    log
  ) {
    const data = {};
    if (barcode) data.barcode = barcode;
    if (phone) data.phone = phone;
    if (createdBy) data.createdBy = createdBy;
    if (startDate) data.startDate = startDate;
    if (endDate) data.endDate = endDate;
    if (log) data.log = log;

    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_MALLLOGISTICS_HANDOVER_LOGS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  GetPostsCompany(token, branchID, status, startDate, endDate, useForce) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_POSTS_GET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        // limit: 5000,
        orderBy: 'created',
        branchID: branchID,
        status: status,
        startDate: startDate,
        endDate: endDate,
        useForce: useForce,
        makeGroup: true,
        showMultipleTransactions: true,
      },
    });
  },

  GetPostsMall(token, mallID, status, startDate, endDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_POSTS_GET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        // limit: 5000,
        orderBy: 'created',
        mallID: mallID,
        status: status,
        startDate: startDate,
        endDate: endDate,
        makeGroup: true,
        showMultipleTransactions: true,
      },
    });
  },

  GetDirections(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_DIRECTIONS_GET}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetVideos(token, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TRAINING_VIDEOS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  GetDocuments(token, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TRAINING_DOCUMENTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  GetFaq(token, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  GetFaqWithoutToken(type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_GET_FAQ}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        type: type,
      },
    });
  },

  CreateFaq(token, faq) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        title: faq.title,
        description: faq.description,
        type: faq.type,
      },
    });
  },

  CreateFaqLog(source, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_CREATE_FAQ_LOGS}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        source,
        type,
      },
    });
  },

  UpdateFaq(token, id, title, description, type) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_UPDATE_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
        title,
        description,
        type,
      },
    });
  },

  RemoveFaq(token, id) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_REMOVE_FAQ}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
      },
    });
  },

  CreatePostTaskCheckList(token, mallID, branchID, description, direction) {
    console.log({ mallID, branchID, description });
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_POST_TASK_CHECKLIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        branchID,
        description,
        direction,
      },
    });
  },

  GetPostTaskCheckList(
    token,
    mallID,
    status,
    startDate,
    endDate,
    branchID,
    taskID
  ) {
    console.log(mallID);
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_POST_TASK_CHECKLIST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  ChangePostTaskCheckListStatus(token, taskID, status) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CHANGE_POST_TASK_CHECKLIST_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        taskID,
        status,
      },
    });
  },

  GetPaymentReceipts(token, mallID, branchID, receiptNo, receiptDate) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_PAYMENT_RECEIPTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
        branchID: branchID,
        receiptNo: receiptNo,
        receiptDate: receiptDate,
      },
    });
  },

  GetBranch(token, branchID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_BRANCH}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchID,
      },
    });
  },

  CreateReceipts(
    token,
    branchID,
    receiptNo,
    receiptDate,
    price,
    isPaid,
    files
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_PAYMENT_RECEIPT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchID,
        receiptNo: receiptNo,
        receiptDate: receiptDate,
        price: price,
        isPaid: isPaid,
        currency: 'TRY',
        files,
      },
    });
  },

  updateReceipts(
    token,
    receiptID,
    branchID,
    receiptNo,
    receiptDate,
    price,
    isPaid,
    files,
    attachments
  ) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_UPDATE_PAYMENT_RECEIPT}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        receiptID: receiptID,
        branchID: branchID,
        receiptNo: receiptNo,
        receiptDate: receiptDate,
        price: price,
        isPaid: isPaid,
        currency: 'TRY',
        files: files,
        attachments: attachments,
      },
    });
  },

  SetPaymentReceiptsStatus(token, paymentReceiptsIDs, isPaid) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_SET_PAYMENT_RECEIPTS_PAYMENT_STATUS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        paymentReceiptsIDs: paymentReceiptsIDs,
        isPaid: isPaid,
      },
    });
  },

  WhatIsMyIP(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_WHAT_IS_MY_IP}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },

  GetInvoiceDetail(invoiceID, taxNo) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_GET_E_PAYMENT_INVOICE}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        invoiceID: invoiceID,
        taxNo: taxNo,
      },
    });
  },

  CreatePaymentRequest(body) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_CREATE_E_PAYMENT_REQUEST}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
    });
  },

  ListenPaymentML(conversationID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_LISTEN_E_PAYMENT}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationID,
      },
    });
  },

  SetPaid(invoice, tax) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_SET_E_PAYMENT_PAID}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        invoiceID: invoice,
        taxNo: tax,
      },
    });
  },

  GetBranchByQR(qrCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_BRANCH_DETAILS_BY_STATIC_QR_CODE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        qrCode,
      },
    });
  },

  CreateBranch(data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_BRANCH_CREATE}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  CreateUserForBranch(data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_USER_CREATE}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  CreateLocation(token, data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_LOCATION_CREATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  CreateLocationWithoutToken(data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_LOCATION_CREATE}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  BranchUpdate(data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_BRANCH_UPDATE}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  LocationUpdate(token, data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_LOCATION_UPDATE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  LocationUpdateWithoutToken(data) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_LOCATION_UPDATE}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  GetLiveAnalyticsMallGeneral(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_MALL_GENERAL,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetLiveAnalyticsMallMalKabul(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_MALL_MAL_KABUL,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },
  GetLiveAnalyticsMallMalKabulList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_MAL_KABUL_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  GetLiveAnalyticsMallMuhaberat(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_MALL_MUHABERAT,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },
  GetLiveAnalyticsMallMuhaberatList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_MUHABERAT_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  GetLiveAnalyticsPetCar(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_PET_CAR,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetLiveAnalyticsPetCarList(token, mallID, startDate, endDate) {
    console.log({ startDate, endDate });
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_PET_CAR_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate,
        endDate,
      },
    });
  },

  GetLiveAnalyticsKidCar(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_KID_CAR,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetLiveAnalyticsKidCarList(token, mallID, startDate, endDate) {
    console.log({ startDate, endDate });
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_KID_CAR_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        // mallID: "43110568739089850859",
        mallID,
        startDate,
        endDate,
      },
    });
  },

  GetLiveAnalyticsHandsfree(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_HANDSFREE,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetLiveAnalyticsHandsfreeList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_HANDSFREE_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        // mallID: "43110568739089850859",
        mallID,
        startDate,
        endDate,
      },
    });
  },

  GetLiveAnalyticsGift(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_GIFT,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetLiveAnalyticsGiftList(token, mallID, startDate, endDate) {
    console.log({ startDate, endDate });
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_GIFT_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        // mallID: "43110568739089850859",
        mallID,
        startDate,
        endDate,
      },
    });
  },

  GetLiveAnalyticsCheckRoom(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_CHECKROOM,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetLiveAnalyticsCheckRoomList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_CHECKROOM_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  GetLiveAnalyticsDropbox(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_DROPBOX,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },

  GetLiveAnalyticsDropboxList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_DROPBOX_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },
  GetLiveAnalyticsClickAndCollect(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_CLICK_AND_COLLECT,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },
  GetLiveAnalyticsClickAndCollectList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_CLICK_AND_COLLECT_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate,
        endDate,
      },
    });
  },
  GetLiveAnalyticsHomeDelivery(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_HOME_DELIVERY,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },
  GetLiveAnalyticsHomeDeliveryList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_ANALYTICS_HOME_DELIVERY_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },
  GetLiveAnalyticsTaxFree(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_TAX_FREE,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },
  GetLiveAnalyticsTaxFreeList(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_TAX_FREE_LIST,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
        startDate,
        endDate,
      },
    });
  },
  GetLiveAnalyticsCargo(token, mallID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_CARGO,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID,
      },
    });
  },
  GetLiveAnalyticsPorter(token, pointID) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_PORTER,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        pointID: pointID,
      },
    });
  },

  GetLiveAnalyticsDistricManager(token, pointIDs, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_DISTRICT_MANAGER,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        pointID: pointIDs,
      },
    });
  },

  GetPorterPerformanceReport(token, mallID, startDate, endDate) {
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_PORTER_PERFORMANCE_REPORT,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        mallID: mallID,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  async calculateVigoPrice(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CALCULATE_VIGO_PRICE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  async createVigoPost(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_VIGO_POST}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },
  async GetThirdPartyCargoCourierPosts(pointID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_THIRD_PARTY_CARGO_COURIER_POSTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        pointID: pointID,
      },
    });
  },

  ListenPayment(conversationID) {
    return axios({
      method: 'post',
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_ENDPOINT_PAYMENT_FLOW_LISTEN}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationID,
        id: '579224568643984170160192132079',
      },
    });
  },

  PaymentWith3D(
    conversationID,
    price,
    name,
    lastname,
    phone,
    holderName,
    cardNumber,
    expYear,
    expMonth,
    cvc
  ) {
    return axios({
      method: 'post',
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_ENDPOINT_PAYMENT_FLOW_PAYMENT_WITH_3D}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationID: conversationID,
        totalPrice: 1,
        paidPrice: 1,
        discount: 0,
        installment: 1,
        currency: 'TRY',
        customer: {
          name: name,
          lastname: lastname,
          phone: phone,
        },
        creditCardInfos: {
          holderName: holderName,
          cardNumber: cardNumber,
          expYear: expYear,
          expMonth: expMonth,
          cvc: cvc,
        },
        willBeStored: false,
        cardAlias: false,
        items: [
          {
            name: 'Vigo Motor Courier',
            price: 1,
          },
        ],
        callback: PAYMENT_3D_CALLBACK_URL,
        id: '579224568643984170160192132079',
      },
    });
  },

  GetPaymentError(conversationID) {
    return axios({
      method: 'post',
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_ENDPOINT_PAYMENT_FLOW_GET_PAYMENT_ERROR}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        conversationID,
        id: '579224568643984170160192132079',
      },
    });
  },
  async createCargoistPost(data) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_KARGOIST_CREATE_CARGO}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    });
  },

  GetCities(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_CITIES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  GetTowns(token, cityCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_TOWNS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        cityCode: cityCode,
      },
    });
  },
  GetRegions(token, townCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_GET_DISTRICTS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        townCode: townCode,
      },
    });
  },

  GetLiveAnalyticsPostBox(token, mallID, startDate, endDate) {
    // token ve mallID parametreleri kullanılacak
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_LIVE_ANALYTICS_POSTBOX,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: mallID,
        startDate: startDate,
        endDate: endDate,
      },
    });
  },
  GetLiveAnalyticsPostBoxList(startDate, endDate, mallID) {
    //parsedUser.token, mallID, startDate, endDate parametreleri kullanılacak
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_POSTBOX_REPORT,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: ['EPPK1'],
        startDate: startDate,
        endDate: endDate,
      },
    });
  },

  createContactForm(token, formData) {
    const formType = 'Hizmet Talebi';

    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_CONTACT_FORM}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        data: {
          ...formData,
        },
        type: formType,
      },
    });
  },
  SendCode(phone, message) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_SEND_SMS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        phone: phone,
        message: message,
      },
    });
  },
  async GetLocationSettings(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_DROP_BOX_GET_LOCATION_SETTINGS,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
      },
    });
  },
  async GetAllCheckroomPrices(locationCode) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CHECKROOM_GET_ALL_PRICES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        locationCode: locationCode,
      },
    });
  },
  async StaffClockingInQR(pointID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_STAFF_CLOCKING_IN_QR}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        pointID: pointID,
      },
    });
  },
  async StaffClockingOutQR(code) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CREATE_STAFF_CLOCKING_OUT_QR}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        code: code,
      },
    });
  },

  async GetIrsaliyeDetail(handshakeID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: process.env
        .REACT_APP_ENDPOINT_ABS_PROD_MALLLOGISTICSAPI_COM_API_FLOW_GET_HANDSHAKE_TRACK_DOCUMENT_INFOS,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        handshakeID: handshakeID,
      },
    });
  },

  GetSurvey(surveyID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_GET_SURVEYS}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        surveyID,
      },
    });
  },

  SaveSurvey(token, payload) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_SURVEY_SAVE_RESPONSE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: payload,
    });
  },
  SendRequestAsAdmin(description) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_USER_REQUEST_AS_ADMIN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        requestAsAdminDescription: description, // Optional
      },
    });
  },
  GetAdminRequestList() {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_LIST_REQUEST_AS_ADMIN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  ConfirmAdminRequest(userID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_CONFIRM_REQUEST_AS_ADMIN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },
  RejectAdminRequest(userID) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_REJECT_REQUEST_AS_ADMIN}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID: userID,
      },
    });
  },
  EditPassword(password) {
    const token = localStorage.getItem('tokenForService');
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_USERS_UPDATE_PROFILE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        password: password,
      },
    });
  },

  AddBranchWarning(token, branchIDs, warningContent) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_ADD_BRANCH_WARNING}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchIDs,
        warningContent: warningContent,
      },
    });
  },

  BlockBranch(token, branchIDs) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_BLOCK_BRANCH}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchIDs,
      },
    });
  },

  RemoveBlockBranch(token, branchIDs) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_REMOVE_BLOCK_BRANCH}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        branchID: branchIDs,
      },
    });
  },

  RemoveBranchWarning(token, warningID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_REMOVE_BRANCH_WARNING}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        warningID: warningID,
      },
    });
  },

  ListBranchWarningsBlockLogs(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_API_FLOW_LIST_BRANCH_WARNINGS_BLOG_LOGS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        token: token,
      },
    });
  },
};
